const ONE_DAY_MS = 24 * 60 * 60 * 1000
const KEY_PREFIX = 'agreement_token'
const KEY_PREFIX_WITH_DELIMITER = `${KEY_PREFIX}:`

function buildKey ({ dealerId, agreementId }) {
  if (!dealerId || !agreementId) return ''
  return `${KEY_PREFIX}:${dealerId}:${agreementId}`
}

export function shouldShowAgreementPopup ({ dealerId, agreementId }) {
  if (typeof window === 'undefined') return false
  const key = buildKey({ dealerId, agreementId })
  if (!key) return false

  const raw = window.localStorage.getItem(key)
  if (!raw) return true

  const lastDismissedAt = parseInt(raw, 10)
  if (Number.isNaN(lastDismissedAt)) {
    window.localStorage.removeItem(key)
    return true
  }

  return (Date.now() - lastDismissedAt) >= ONE_DAY_MS
}

export function setAgreementTimestampToken ({ dealerId, agreementId }) {
  if (typeof window === 'undefined') return
  const key = buildKey({ dealerId, agreementId })
  if (!key) return
  window.localStorage.setItem(key, Date.now().toString())
}

export function clearAgreementTimestampToken ({ dealerId, agreementId }) {
  if (typeof window === 'undefined') return
  const key = buildKey({ dealerId, agreementId })
  if (!key) return
  window.localStorage.removeItem(key)
}

export function clearAllAgreementTimestampTokens () {
  if (typeof window === 'undefined') return
  const { localStorage } = window
  if (!localStorage) return

  // Iterate backwards since we're deleting keys as we go.
  for (let i = localStorage.length - 1; i >= 0; i -= 1) {
    const key = localStorage.key(i)
    if (key && key.startsWith(KEY_PREFIX_WITH_DELIMITER)) {
      localStorage.removeItem(key)
    }
  }
}

